import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import MachineLearning from 'views/machineLearning';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../meta/config';

class MLPage extends Component {
  render() {
    const page = pages['machine-learning'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/machine-learning/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Machine Learning Services">
          <meta
            name={'description'}
            content={
              'Our AI team can help your company with applying Machine Learning and Deep Neural Networks.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect />
        <MachineLearning allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query MLQuery {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "Building digital products based on machine learning - the cost perspective"
              "How to start a neural network with JavaScript in 5 minutes"
              "Speeding up e-commerce content moderation with Machine Learning based on Amazon Web Services"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default MLPage;
